import { cn } from "@/lib/utils";

export const PageHeader = ({
  title,
  subtitle,
  description,
  eyebrow,
  icon: Icon,
  actions,
  filters,
  status,
  className,
  titleClassName,
  testId = "page-header",
}) => {
  const body = subtitle || description;

  return (
    <header className={cn("mb-8 md:mb-10 min-w-0", className)} data-testid={testId}>
      {eyebrow ? (
        <p className="page-eyebrow">{eyebrow}</p>
      ) : null}

      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between min-w-0">
        <div className="min-w-0 flex-1">
          <div className="flex items-start gap-3 min-w-0">
            {Icon ? (
              <Icon
                className="w-6 h-6 text-brand-primary shrink-0 mt-1"
                strokeWidth={1.5}
                aria-hidden="true"
              />
            ) : null}
            <div className="min-w-0">
              <h1
                className={cn("page-title", titleClassName)}
              >
                {title}
              </h1>
              {body ? (
                <p className="page-subtitle">{body}</p>
              ) : null}
            </div>
          </div>
          {status ? <div className="mt-3">{status}</div> : null}
        </div>

        {actions ? (
          <div className="flex flex-wrap items-center gap-2 shrink-0 w-full lg:w-auto">{actions}</div>
        ) : null}
      </div>

      {filters ? <div className="mt-6 min-w-0">{filters}</div> : null}
    </header>
  );
};
